import { render, staticRenderFns } from "./Migrate.vue?vue&type=template&id=72e702a6&scoped=true"
import script from "./Migrate.vue?vue&type=script&lang=js"
export * from "./Migrate.vue?vue&type=script&lang=js"
import style0 from "./Migrate.vue?vue&type=style&index=0&id=72e702a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e702a6",
  null
  
)

export default component.exports